import {Observer} from 'mobx-react';
import styled from 'styled-components';

import {i18n} from '@yourcoach/i18n';

import {alert} from '../../../../components/alert';
import {getColor, getRem, ms} from '../../../../styles';
import {Text} from '../../../../uikit/Text';
import {TextArea} from '../../../../uikit/TextArea';
import {View} from '../../../../uikit/View';
import {logger} from '../../../../utils/logger';
import {createTextInputField} from '../../../../utils/validation';
import {COMMAND} from '../../utils';

type ConfirmResult =
  | typeof COMMAND.CANCEL
  | {
      reason?: string;
    };

const REASON_MAX_LENGTH = 255;

type Props = {
  isForCoach?: boolean;
};

export const membershipDeclineReasonConfirm = (
  {isForCoach}: Props = {
    isForCoach: false,
  },
) => {
  const reason = createTextInputField('reason', {
    validationRule: {
      max: REASON_MAX_LENGTH,
      messages: {
        stringMax: i18n.t('shared:reason_max_length_error', {
          maxLength: REASON_MAX_LENGTH,
        }),
      },
      optional: true,
      type: 'string',
    },
  });

  const onConfirm = (resolve: (value: ConfirmResult) => void) => {
    if (!reason.validate()) {
      return;
    }

    logger.event('invite_decline_reason_tap');

    resolve({reason: reason.value.trim()});
  };
  const onCancel = (resolve: (value: ConfirmResult) => void) =>
    resolve(COMMAND.CANCEL);

  return alert.show({
    beforeButtonsSlot: () => (
      <ReasonContainer>
        <Observer>
          {() => (
            <>
              <Description>{i18n.t('shared:reason')}</Description>
              <ReasonInput
                error={reason.error ?? ''}
                onChange={reason.onChange}
                placeholder={i18n.t('shared:provide_reason_why_declining')}
              />
            </>
          )}
        </Observer>
      </ReasonContainer>
    ),
    buttons: [
      {
        label: i18n.t('shared:decline_invite'),
        onAwaitableClick: onConfirm,
        scheme: isForCoach ? 'primary' : 'secondary',
      },
      {
        label: i18n.t('shared:cancel'),
        onAwaitableClick: onCancel,
        scheme: 'gray',
      },
    ],
    isDismissible: true,
    onAwaitableDismiss: onCancel,
    title: i18n.t('shared:decline_invite'),
    titleAlign: 'left',
  });
};

const ReasonContainer = styled(View)`
  margin: 0 ${ms(20)} ${ms(16)};
  flex-direction: column;
`;

const ReasonInput = styled(TextArea)`
  height: ${ms(88)};
  resize: vertical;
`;

const Description = styled(Text).attrs({
  weight: 'semibold',
})`
  margin-block-end: ${ms(8)};
  font-size: ${getRem(14)};
  line-height: ${getRem(20)};
  letter-spacing: ${getRem(-0.08)};
  color: ${getColor('text1')};
`;
